import React from 'react'
import { sizes, socialIconColors } from './const'
export interface TwitterProps {
    /**
     * This allows to pass a custom className to the component.
     * i.e. className="js_TrackIcon", which is used for Google Analitics.
     */
    className?: string
    /**
     * The size we can use for the icon: small, medium, large.
     * small = 16px, medium = 24px, large = 32px.
     *
     */
    size?: 'small' | 'medium' | 'large'

    /**
     * The color of the icon including the cirlce.
     * */
    color?: 'white' | 'black'
}

export const TwitterIcon = ({
    className = 'js_TwitterIcon',
    size = 'large',
    color = 'black',
}: TwitterProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`${className} ${sizes[size]}`}
            fill="none"
            viewBox="0 0 32 32"
        >
            <g fillRule="evenodd">
                <circle
                    className={`${socialIconColors[color][0]}`}
                    cx={16}
                    cy={16}
                    r={15.5}
                />
                <path
                    className={`${socialIconColors[color][1]}`}
                    d="M21.83 12.493a2.91 2.91 0 0 0 1.25-1.613 5.601 5.601 0 0 1-1.807.707 2.805 2.805 0 0 0-2.076-.92c-1.57 0-2.843 1.305-2.843 2.916 0 .228.025.45.073.664-2.363-.122-4.458-1.282-5.862-3.048a2.97 2.97 0 0 0-.385 1.468c0 1.01.502 1.904 1.265 2.427a2.792 2.792 0 0 1-1.288-.364v.036c0 1.413.98 2.592 2.282 2.86-.239.068-.49.102-.75.102-.183 0-.362-.017-.535-.052.362 1.158 1.412 2.002 2.657 2.025A5.616 5.616 0 0 1 9.6 20.91a7.918 7.918 0 0 0 4.36 1.309c5.231 0 8.092-4.443 8.092-8.297 0-.127-.003-.254-.008-.378a5.837 5.837 0 0 0 1.418-1.51 5.555 5.555 0 0 1-1.633.46z"
                />
            </g>
        </svg>
    )
}
